import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { ButtonLink, FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import Link from "next/link";

export default function ChannelPickupListRow({ item }) {
  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      className={classnames(styles.container, styles.pickup, {
        [styles.notAllowed]: !item.isAllowedRating,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.artwork}>
          <CardArtwork
            item={item}
            className={styles.artworkInner}
            href={routes.channelDetail(item.id)}
            linkAttr={{ onClick: handleClick }}
          />
        </div>
        <div className={styles.info}>
          <h4 className={styles.title}>
            <Link href={routes.channelDetail(item.id)} onClick={handleClick}>
              {item.name}
            </Link>
          </h4>
          <div className={styles.genre}>
            <span>{item.genres.map((genre) => genre.name).join("/")}</span>
          </div>
          <p className={styles.description}>{item.description}</p>
          <div className={styles.buttons}>
            <ButtonLink
              fillColor
              medium
              href={routes.channelDetail(item.id)}
              disabled={!item.isAllowedRating}
            >
              詳細を見る
            </ButtonLink>
            <FavoriteButton
              transparent
              borderGray
              metaId={item.id}
              text="お気に入り"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
